<template>
    <Head title="News Pages"/>
    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="grid grid-flow-col gap-4">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                        News Pages
                    </h2>
                </div>
                <div class="text-right">
                    <admin-link :href="`/admin/news/create`" title="Create New">Create New</admin-link>
                </div>
            </div>
        </template>
        <BreadCrumbs :items="breadCrumbs"></BreadCrumbs>
        <div class="relative w-full py-12 my-6 overflow-hidden shadow">
            <form @submit.prevent="form.get('news')">
                <admin-search-form v-model="form.search"></admin-search-form>
            </form>
            <div class="px-2 md:px-6 pt-2 md:pt-4 pb-2">
                <div class="overflow-x-auto">
                    <div class="inline-block min-w-full overflow-hidden">
                        <table class="w-full table-auto md:table-fixed">
                            <thead class="uppercase text-gray-600 text-xs font-semibold bg-gray-200">
                            <tr class="hidden lg:table-row">
                                <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">
                                    ID
                                </th>
                                <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">
                                    Name
                                </th>
                                <th class="bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider">
                                    &nbsp;
                                </th>
                            </tr>
                            </thead>
                            <tbody class="my-3 flex-1 lg:flex-none">
                            <tr v-if="pages.data.length"
                                v-for="page of pages.data"
                                class="mb-2 lg:mb-0 border-2 lg:border-b-2 border-grey-200 lg:border-t lg:first:border-t-0 flex p-1 md:p-3 hover:bg-gray-100 lg:table-row flex-col w-full flex-wrap">
                                <td class="p-1 lg:p-5 lg:border-l-2 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                    <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">ID</label>
                                    {{ page.id }}
                                </td>
                                <td class="p-1 lg:p-5 lg:border-b border-grey-200 bg-white text-sm md:text-base">
                                    <label class="mb-3 bg-grey-100 border-b-2 border-grey-200 font-semibold px-5 py-3 uppercase text-sm text-left tracking-wider block lg:hidden">Title</label>
                                    {{ page.title }}
                                </td>
                                <td class="px-5 py-5 lg:border-r lg:border-b border-grey-200 bg-white text-center lg:text-left text-sm md:text-base">
                                    <admin-link :href="route('admin.news.edit', page)">Edit</admin-link>
                                    <admin-link type="button" class="bg-red" @click="showDeleteModal(page.id)">Delete
                                    </admin-link>
                                    <admin-delete-modal v-if="deleteModalIdToShow === page.id"
                                                        :msg="modalMessage"
                                                        :type="modalType"
                                                        @toggle-delete-modal="hideDeleteModal()"
                                                        @delete-item="deleteItem(page)"></admin-delete-modal>
                                </td>
                            </tr>
                            <tr v-else>
                                <td class="py-6 bg-red" colspan="3" align="center">
                                    <p class="text-white font-bold">No news pages found</p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <admin-pagination class="my-6" :links="pages.links"/>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>

<script>
import AdminPagination from "@/Components/Admin/AdminPagination";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import AdminLink from "@/Components/Admin/AdminLink";
import AdminSearchForm from "@/Components/Admin/Forms/AdminSearchForm";
import AdminDeleteModal from "@/Components/Admin/AdminDeleteModal";

import {Head, useForm} from "@inertiajs/inertia-vue3";

export default {
    name: "Index",
    components:
        {
            AdminDeleteModal,
            AdminPagination,
            AdminSearchForm,
            BreezeAuthenticatedLayout,
            AdminLink,
            BreadCrumbs,
            Head
        },
    props: {
        pages: Object,
        term: String
    },
    data() {
        return {
            breadCrumbs: [
                {title: "News", path: "/news/news"}
            ],
            deleteModalIdToShow: false,
            modalMessage: "Are you sure you want to delete this news page?",
            modalType: "News",
            form: useForm({
                search: this.term
            })
        };
    },
    methods: {
        showDeleteModal(id) {
            this.deleteModalIdToShow = id;
        },
        hideDeleteModal() {
            this.deleteModalIdToShow = false;
        },
        deleteItem(page) {
            this.$inertia.delete(route("admin.news.destroy", page));
        }
    }
};
</script>

<style scoped>

</style>
